import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/context/ContentContext";
import SiteLayout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Bridal from "@/pages/Bridal";
import Bunad from "@/pages/Bunad";
import Courses from "@/pages/Courses";
import Prices from "@/pages/Prices";
import Booking from "@/pages/Booking";
import { About, Gallery, Contact, Privacy } from "@/pages/InfoPages";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Inquiries from "@/pages/admin/Inquiries";
import PricesAdmin from "@/pages/admin/PricesAdmin";
import CoursesAdmin from "@/pages/admin/CoursesAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import Marketing from "@/pages/admin/Marketing";
import Chats from "@/pages/admin/Chats";
import ImagesAdmin from "@/pages/admin/ImagesAdmin";
import BooksAdmin from "@/pages/admin/BooksAdmin";
import Accounting from "@/pages/admin/Accounting";
import { BookProduct, BookReader } from "@/pages/Book";
import { BookPayment } from "@/components/site/BookCheckout";

function App() {
  return (
    <BrowserRouter>
      <ContentProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/tjenester" element={<Services />} />
            <Route path="/bunad" element={<Bunad />} />
            <Route path="/brudekjoler" element={<Bridal />} />
            <Route path="/sykurs" element={<Courses />} />
            <Route path="/priser" element={<Prices />} />
            <Route path="/bestill" element={<Booking />} />
            <Route path="/om-liisa" element={<About />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/personvern" element={<Privacy />} />
            <Route path="/handbok" element={<BookProduct />} />
            <Route path="/handbok/betaling" element={<BookPayment />} />
          </Route>
          <Route path="/handbok/les/:token" element={<BookReader />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Overview />} />
            <Route path="henvendelser" element={<Inquiries />} />
            <Route path="priser" element={<PricesAdmin />} />
            <Route path="sykurs" element={<CoursesAdmin />} />
            <Route path="samtaler" element={<Chats />} />
            <Route path="bilder" element={<ImagesAdmin />} />
            <Route path="handbok" element={<BooksAdmin />} />
            <Route path="markedsforing" element={<Marketing />} />
            <Route path="regnskap" element={<Accounting />} />
            <Route path="innstillinger" element={<SettingsAdmin />} />
          </Route>
        </Routes>
        <Toaster position="top-center" />
      </ContentProvider>
    </BrowserRouter>
  );
}

export default App;
